/*
 * School Management System API
 * APIs for managing branches, employees, students, receipts, etc.
 *
 * OpenAPI spec version: 1.0.0
 * Contact: tejabhargavpodila@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.54
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The DbUpdateRequest model module.
 * @module model/DbUpdateRequest
 * @version 1.0.0
 */
export default class DbUpdateRequest {
  /**
   * Constructs a new <code>DbUpdateRequest</code>.
   * @alias module:model/DbUpdateRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>DbUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DbUpdateRequest} obj Optional instance to populate.
   * @return {module:model/DbUpdateRequest} The populated <code>DbUpdateRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DbUpdateRequest();
      if (data.hasOwnProperty('collectionName'))
        obj.collectionName = ApiClient.convertToType(data['collectionName'], 'String');
      if (data.hasOwnProperty('query'))
        obj.query = ApiClient.convertToType(data['query'], Object);
      if (data.hasOwnProperty('update'))
        obj.update = ApiClient.convertToType(data['update'], Object);
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} collectionName
 */
DbUpdateRequest.prototype.collectionName = undefined;

/**
 * @member {Object} query
 */
DbUpdateRequest.prototype.query = undefined;

/**
 * @member {Object} update
 */
DbUpdateRequest.prototype.update = undefined;

/**
 * Allowed values for the <code>type</code> property.
 * @enum {String}
 * @readonly
 */
DbUpdateRequest.TypeEnum = {
  /**
   * value: "updateOne"
   * @const
   */
  updateOne: "updateOne",

  /**
   * value: "updateMany"
   * @const
   */
  updateMany: "updateMany"
};
/**
 * @member {module:model/DbUpdateRequest.TypeEnum} type
 */
DbUpdateRequest.prototype.type = undefined;

